import { render } from "./health-center-page.vue?vue&type=template&id=ca7677f8&scoped=true"
import script from "./health-center-page.vue?vue&type=script&lang=js"
export * from "./health-center-page.vue?vue&type=script&lang=js"

import "./health-center-page.scss?vue&type=style&index=0&id=ca7677f8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7677f8"]])

export default __exports__